import React, { useRef } from 'react';
import { useQuickView, useSlides } from 'components/quickView';
import { useOpenSurveyQuickView } from 'components/surveySystem/shared/hooks/useOpenSurveyQuickView';
import { GA4Tracking } from 'modules/tracking/GA4/GA4Tracking';
import { v4 as uuidv4 } from 'uuid';
import SlideView from './components/slideView';
import ToolboxCard from './components/toolboxCard';
import { trackingEventNameMapper } from './shared/helper';
import { Item, List } from './shared/styles';
import type { AdvisorToolboxItemWithId, IAdvisorToolbox } from './shared/types';

export default function ToolboxQuickView(props: IAdvisorToolbox) {
    const { model, productId } = props;
    const { items } = model;
    const { toggle } = useQuickView('advisorToolbox');
    const { openSurveyQuickViewBySurveyId } = useOpenSurveyQuickView();
    const { push } = useSlides();
    const itemsWithId: AdvisorToolboxItemWithId[] = useRef(items.map((x) => ({ ...x, id: uuidv4() }))).current;

    function showNextSlide(item: AdvisorToolboxItemWithId) {
        return async () => {
            const { quickView, type, surveyId } = item;
            const eventName = trackingEventNameMapper(type);

            if (surveyId) {
                openSurveyQuickViewBySurveyId({ surveyId }).then(() => toggle(false));
            }

            if (quickView) {
                push({
                    id: item.id,
                    SlideComponent: () => <SlideView quickView={{ ...quickView, type, productId }} />
                });

                if (eventName) {
                    GA4Tracking({ eventName, context: 'advisor_toolbox', category: 'advisory' });
                }
            }
        };
    }

    return (
        <List>
            {itemsWithId.map((item) => (
                // eslint-disable-next-line react/no-array-index-key
                <Item key={item.id}>
                    <ToolboxCard item={item} onClick={showNextSlide(item)} />
                </Item>
            ))}
        </List>
    );
}
